<template>
  <b-container class="mt-4">
      <b-alert variant="danger" :show="showValidationMessage"> {{validationMessage}} </b-alert>

    <b-form @submit.prevent="Login()">
      <b-form-group
                    label="Email address:">
        <b-form-input 
                      type="email"
                      v-model="email"
                      required
                      placeholder="Enter email">
        </b-form-input>
      </b-form-group>

      <b-form-group 
                    label="Password:">
        <b-form-input 
                      type="password"
                      v-model="password"
                      required
                      placeholder="Enter a secure password">
        </b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary">Login</b-button>
      <div class="mt-2">
        <b-link :to="{name: 'forgot'}"> Forgot Password</b-link>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import AuthService from "../../services/AuthService";

export default {
  name: "SignUp",
  data() {
    return {
      email: "",
      password: "",
      showValidationMessage : false,
      validationMessage : ""
    };
  },
  methods: {
    Login() {
      //var vm = this;

      AuthService.Authenticate(this.email, this.password).then(r => {
        if(r.data.Result === 'OK') {
          AuthService.GetUserDetails()
            .then((result) => {
              if(result.data.length > 0) {
                var roles = AuthService.GetRoles();
                this.$store.commit("SetCredentials", { username: this.email, userInfo: result.data[0], roles: roles } );
                //Check if this is first login;
                
                // const LastLoginTs = new Date(r.data.LastLogin).getTime();
                // const nowTs = Date.now();
                // const minutesPassed = (nowTs - LastLoginTs) / 60000
                if(r.data.LastLogin){
                  this.$router.push({ path: '/' });
                }
                else {
                  this.$router.push({ path: '/profile' });
                }
                
              }
              else
              {
                this.validationMessage = "Invalid username or password. Please contact the office on (02) 8850 7992 to reset your password";
                this.showValidationMessage = true;
              }
            })
            .catch(() => {
                this.validationMessage = "Invalid username or password. Please contact the office on (02) 8850 7992 to reset your password";
                this.showValidationMessage = true;
            });
        }
        else{
          this.validationMessage = "Invalid username or password. Please contact the office on (02) 8850 7992 to reset your password";
          this.showValidationMessage = true;
        }
      }).catch(r => {
        this.validationMessage = "Invalid username or password. Please contact the office on (02) 8850 7992 to reset your password";
        this.showValidationMessage = true;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/login.vue